// A step's waiting line (needs.waitingText) that opens to name the items holding it up,
// each with its reason alone: never who decided it or when (Noaa, 19 Oct 2026).
import type { AmazonNeed } from "../../api/hooks/useAmazonOverview";
import { Chevron } from "../../components/Chevron";
import { whyText } from "./needs";
import styles from "./amazonOverview.module.css";

export const HeldItems = ({ line, held }: { line: string; held: AmazonNeed[] }) =>
  held.length ? (
    <details className={styles.heldItems}>
      <summary>
        {line} <Chevron />
      </summary>
      <ol>
        {held.map((n) => (
          <li key={n.key}>
            {n.text}
            {whyText(n) && <span className={styles.heldWhy}>Why: {whyText(n)}.</span>}
          </li>
        ))}
      </ol>
    </details>
  ) : (
    <p>{line}</p>
  );
